/** the price impact under which no order gets a warning (John, Nov 4 2026: "i dont need PI warnings under 2.5%"; 1% before) */
export const IMPACT_WARN_PCT = 2.5

/**
 * A price impact is worth a warning when it is at least IMPACT_WARN_PCT and costs at
 * least a dollar; on a small order the reading is noise and the money at
 * stake is cents (John, Oct 29 2026: a 63 cent sale showed 1.47%).
 */
export function impactWarns(pct: number | null | undefined, valueUsd: number | undefined): pct is number {
  return pct !== null && pct !== undefined && pct >= IMPACT_WARN_PCT && valueUsd !== undefined && (valueUsd * pct) / 100 >= 1
}
